module.exports = __webpack_public_path__ + "media/images/hero/dots-0e712754dc7462b51640b5cb59df8d55.svg";